// src/whatsappChat/routes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from '../components/PrivateRoute.jsx';
import WaChatLayout, { RequireWaRight } from './components/WaChatLayout';
import { WA_CHAT_PATH } from './components/WaChatNav';
import InboxPage from './pages/InboxPage';
import TemplatesPage from './pages/TemplatesPage';
import TemplateCreatePage from './pages/TemplateCreatePage';
import SetupPage from './pages/SetupPage';

/**
 * All WhatsApp Chat routes. Mounted once in App.js as {whatsappChatRoutes}.
 * The parent is gated on the `whatsapp_chat` role key; each page is gated on
 * the matching right from GET /permissions.
 */
export const whatsappChatRoutes = (
  <Route
    path={WA_CHAT_PATH}
    element={<PrivateRoute module="whatsapp_chat" action="view" element={<WaChatLayout />} />}
  >
    <Route
      index
      element={
        <RequireWaRight right="inbox.view">
          <InboxPage />
        </RequireWaRight>
      }
    />
    <Route
      path="templates"
      element={
        <RequireWaRight right="templates.view">
          <TemplatesPage />
        </RequireWaRight>
      }
    />
    <Route
      path="templates/add"
      element={
        <RequireWaRight right="templates.create">
          <TemplateCreatePage />
        </RequireWaRight>
      }
    />
    <Route
      path="setup"
      element={
        <RequireWaRight right="setup.view">
          <SetupPage />
        </RequireWaRight>
      }
    />
  </Route>
);
